<script>
import bus from 'vue3-eventbus'
export default {
  props: {
    earn: String
  },
  data () {
    return {
      userData: {},
      levelPic: [
        require('@/assets/level_big_bronze.png'),
        require('@/assets/level_big_silver.png'), require('@/assets/level_big_gold.png'),
        require('@/assets/level_big_platinum.png'), require('@/assets/level_big_diamond.png'),
        require('@/assets/level_big_king.png')],
      levelTxtBg: [
        require('@/assets/bronze_txt_bg.png'),
        require('@/assets/silver_txt_bg.png'), require('@/assets/gold_txt_bg.png'),
        require('@/assets/platinum_txt_bg.png'), require('@/assets/diamond_txt_bg.png'),
        require('@/assets/king_txt_bg.png')],
    }
  },
  computed: {
    levels () {
      console.log(this.$store.state.appConfig)
      return this.$store.state.appConfig.level ? this.$store.state.appConfig.level : []
    }
  },
  methods: {
    dissmiss () {
      bus.emit('dismissEarnTips')
    },
    nomal () {
    }
  },
  mounted () {
    const user = this.$store.state.user
    if (user) {
      this.userData = user
    }
  },
}
</script>

<template>
  <div class="root">
    <img style="margin-top: -1rem; width: 59rem; height: 7rem;" src="../../assets/iv_congratulations.png">
    <!-- <p style="margin-top: -1rem; color: #FFEE34; font-size: 4.8rem; align-self: center; font-weight: 800;">Awesome!</p> -->
    <div class="amount">
      <p style="font-size: 4.4rem; color: #FFE000;">${{ earn }}</p>
    </div>


    <div style="display: flex; flex-direction: row; align-self: center; margin-top: auto; margin-bottom: -5rem;">
      <p class="negative" @click="dissmiss">GOT IT</p>
    </div>

  </div>
</template>

<style scoped>


.level-img {
  position: absolute;
  height: 27rem;
  width: 27rem;  
  background-size: cover;
  background-repeat: no-repeat;
  align-self: center;
  margin-top: 10rem;
}

.level-rate {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  align-self: center;
  margin-top: 2rem;
}

.positive {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  font-weight: 400;
  line-height: 6rem;
  background-image: url("@/assets/bg_logout_confirm.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.positive:active {
  opacity: 0.6;
}

.negative {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  line-height: 6rem;
  font-weight: 400;
  background-image: url("@/assets/bg_logout_cancel.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.negative:active {
  opacity: 0.6;
}


.root {
  width: 58.6rem;
  height: 40.4rem;
  background-image: url("@/assets/bg_earn_money.png");
  background-size: 100% 95%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-self: center;
}

.root > img {
  width: 28.3rem;
  height: 10.5rem;
  align-self: center;
}

.amount {
  width: 40.3rem;
  height: 7.9rem;
  color: #FFFAC4;
  background-image: url("@/assets/bg_earn_money_amount.png");
  background-size: cover;
  background-repeat: no-repeat;
  align-self: center;
  margin-top: 23rem;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
}

.content {
  width: auto;
  height: auto;
  color: #CCC0FF;
  font-size: 2.0rem;
  align-content: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
}

.root > img:active {
  opacity: 0.6;
}



.no-border-right {
  border-right: 0 solid transparent;
}

.img-contain {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.img-cell {
  background-size: cover;
}

.cell-bg {
  background-color: #F3B25633;
}
</style>
